import { hexagonGrid } from '../components/hexagon-grid';

hexagonGrid('#values');
